<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 fxLayout="column" fxLayoutAlign="center center">{{'PERFILES.USUARIO.ACC-EDIT' | translate}}</h1>

<div fxLayout="column" fxLayoutAlign="start stretch">
  <div class="" fxLayout="row" fxLayoutAlign="space-between start" >
    <div class="" fxLayout="column"  fxFlex="40">
      <mat-form-field appearance="outline">
        <mat-label>{{'PERFILES.USUARIO.USUARIO' | translate}}</mat-label>
        <input matInput  [(ngModel)]="usuario">
        <mat-icon matSuffix class="secondary-text">email</mat-icon>
        <mat-error>{{'PERFILES.USUARIO.USUARIOREQUIRED' | translate}}</mat-error>
      </mat-form-field>
    </div>
    <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="40">
      <mat-form-field appearance="outline"  fxFlex="40">
        <mat-label>{{'PERFILES.USUARIO.CONTRA' | translate}}</mat-label>
        <input matInput type="password" [(ngModel)]="password"  (keyup)="validarPass($event)">
        <mat-icon matSuffix class="secondary-text">lock</mat-icon>
        <mat-error>{{'PERFILES.USUARIO.CONTRAREQUIRED' | translate}}</mat-error>
      </mat-form-field>
      <mat-progress-bar mode="determinate" value="{{medirPass}}" class="valor"></mat-progress-bar>
    </div>
    <div class="modalReglas" fxFlex="20">
  <div *ngFor="let reglas of regalasPass" fxLayout="row" fxLayoutAlign="start center" style="margin-top:0px;">
    {{'PERFILES.USUARIO.'+reglas.regla | translate}}
    <mat-icon *ngIf="!reglas.estatus" class="iconletrasReglasFalse">highlight_off</mat-icon>
    <mat-icon *ngIf="reglas.estatus" class="iconletrasReglasTrue">check_circle_outline</mat-icon>
  </div>
  </div>

</div>

<mat-form-field class="nivel" appearance="outline" fxFlex="100">
  <mat-label>{{'PERFILES.USUARIO.NIVEL' | translate}}</mat-label>
  <mat-select required [(value)]="nivelDefault" >
    <mat-option *ngFor="let level of levelsEdit" [value]="level.nivel" (click)="selectNivelUse(level.nivel)">
      {{'PERFILES.USUARIO.NIVELES.'+level.nivel | translate}}
    </mat-option>
  </mat-select>
  <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
  <mat-error>{{'PERFILES.USUARIO.LEVELREQUIRED' | translate}}</mat-error>
</mat-form-field>

<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="nivelDefault == 19" style="margin-bottom:16px">
  <mat-radio-group aria-label="Select an option" [(ngModel)]="versDefaultLevelResultV2">
  <mat-radio-button value="1" style="margin-left:16px" (change)="cambiarVersionUpdUser($event.value)">{{'CONSULTATABLA.TEX_VERS_RESULT_OPC1' | translate}}</mat-radio-button>
  <mat-radio-button value="2" style="margin-left:16px" (change)="cambiarVersionUpdUser($event.value)">{{'CONSULTATABLA.TEX_VERS_RESULT_OPC2' | translate}}</mat-radio-button>
  </mat-radio-group>
   <mat-form-field appearance="outline" fxFlex="30" style="margin-left:16px" *ngIf="!versDisabledTextLevelResultV2">
      <mat-label>{{'CONSULTATABLA.TEX_VERS_RESULT_LAB' | translate}}</mat-label>
      <input matInput [(ngModel)]='versTextLevelResultV2' placeholder="{{'CONSULTATABLA.TEX_PLAC_RESULT_LAB' | translate}}">
      <mat-icon matSuffix class="disabled-text">edit</mat-icon>
  </mat-form-field>
</div>

<div  fxLayout="row"  style="width:100%"  *ngIf="nivelDefault==1 ||nivelDefault==4||nivelDefault==5 ||nivelDefault==8||nivelDefault==9 ||nivelDefault==10 ||nivelDefault==12||nivelDefault==13||nivelDefault==14||nivelDefault==15||nivelDefault==19">
  <mat-form-field  appearance="outline">
    <mat-label>{{'PERFILES.USUARIO.TITUBUSCAREMPRESA' | translate}}</mat-label>
    <input matInput [(ngModel)]="busquedaEmpresa" (keyup)="getListaEmpresas(1,2)" placeholder="{{'CONSULTATABLA.BUSCAR_PLACEH' | translate}}">
    <mat-icon matSuffix class="secondary-text">search</mat-icon>
  </mat-form-field>

  <mat-form-field  appearance="outline"  style="width:100%">
    <mat-label>{{'PERFILES.USUARIO.COMPANY' | translate}}</mat-label>
    <mat-select required [(value)]="selectedEnterpriseBusU" fxLayoutAlign="space-between center">
      <mat-option *ngFor="let enterprise of enterprises | filter:busquedaEmpresa" [value]="enterprise._id" (click)="institutoEmpresa(enterprise.datosEmpresa.institutoEmpresa)" >
        <div class="" fxLayout="row" fxLayoutAlign="space-between center">
          <h6>{{enterprise.datosEmpresa.nombreEmpresa}}</h6>
          <h3>({{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.INSTITUTOS.'+enterprise.datosEmpresa.institutoEmpresa | translate}})</h3>
        </div>
      </mat-option>
    </mat-select>
    <mat-icon matSuffix class="secondary-text">business</mat-icon>

    <mat-error>{{'PERFILES.USUARIO.COMPANY_REQUIRED' | translate}}</mat-error>
  </mat-form-field>

</div>
<div fxLayout="row" style="width:100%" *ngIf="nivelDefault==2||nivelDefault==11">
  <mat-form-field appearance="outline" style="width:100%">
    <mat-label>{{'PERFILES.EMPRESA.SECCIONES.SEC1.INSTITUTO' | translate}}</mat-label>
    <mat-select required [(value)]="instituto">
      <mat-option *ngFor="let institute of institutes" [value]="institute.numInstituto" (click)="institutoEmpresaElegido(institute.numInstituto)">
        {{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.INSTITUTOS.'+institute.numInstituto | translate}}
      </mat-option>
    </mat-select>
    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
    <mat-error>{{'PERFILES.EMPRESA.SECCIONES.SEC1.INSTITUTO_REQUIRED' | translate}}</mat-error>
  </mat-form-field>

</div>
</div>



<button mat-raised-button style="width:100%" color="accent" (click)="updateUsuario(usuario,password,nivelDefault,selectedEnterpriseBusU,instituto)" [disabled]="!passwordOk && !selectedEnterpriseBusU || passwordOk && !selectedEnterpriseBusU || !passwordOk && selectedEnterpriseBusU" >{{'PERFILES.USUARIO.GUARDA' | translate}}</button>
